// @ts-strict-ignore
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ValidatingFormComponent } from '@/hybrid/formbuilder/formBuilder.module';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from '@/hybrid/formbuilder/formbuilder.utilities';
import { HelpIcon } from '@/hybrid/core/Icon.atom';
import { useShowError } from '@/hybrid/formbuilder/hooks/useShowError';
import { FormFieldWrapper } from '@/hybrid/formbuilder/FormFieldWrapper';

export interface PatternIF extends ValidatingFormComponent<string> {
  component: 'PatternFormComponent';
  min: number;
  max: number;
  label?: string;
}

export const PatternFormComponent: React.FunctionComponent<PatternIF> = (props) => {
  const {
    name,
    testId = 'pattern',
    label,
    tooltip,
    min,
    max,
    validation,
    extendValidation,
    extraClassNames,
    customErrorText,
  } = props;

  const defaultValidation = () => min === max;

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  const { t } = useTranslation();
  const formState = useForm().getState();
  const { showError, setShowError } = useShowError(false);

  return (
    <FormFieldWrapper
      testId={testId}
      extraClassNames={extraClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const formFieldProps = getFormFieldProps(formState, input, meta, props);
          setShowError(formFieldProps.showError);

          return (
            <div className="flexColumnContainer">
              <div>{t(label)}</div>
              {tooltip && <HelpIcon tooltip={tooltip} extraClassNames="text-interactive pl5" />}
            </div>
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
